
<template>
  <div
    v-if="active"
    class="modal-light-container backdrop-blur-lg"
  >
    <div class="modal-light-body">
      <div class="modal-light-card">
        <div class="modal-light-spinner" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "LoaderOverlay",
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {},
});
</script>

<style scoped>
.modal-light-container {
  position: fixed;
  z-index: 1040;
  left: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(15, 23, 42, 0.08);
}
.modal-light-body {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.modal-light-card {
  width: 84px;
  height: 84px;
  border-radius: 22px;
  background: #ffffff;
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-light-spinner {
  width: 48px;
  height: 48px;
  border-radius: 999px;
  background: conic-gradient(#111827 0deg, #111827 120deg, rgba(17, 24, 39, 0.12) 120deg 360deg);
  -webkit-mask: radial-gradient(farthest-side, transparent calc(100% - 6px), #000 calc(100% - 6px));
  mask: radial-gradient(farthest-side, transparent calc(100% - 6px), #000 calc(100% - 6px));
  animation: modal-spinner-rotate 0.9s linear infinite;
  box-shadow: 0 0 14px rgba(17, 24, 39, 0.18);
}

@keyframes modal-spinner-rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
